// AUTO GENERATED FILE - Changes WILL be lost.
// ru - used as 'ru' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Игровой купон",
  "product.last60-row-single": "НБА Последние 60 одиночных матчей",
  "product.sb-english-single": "Английские футбольные ставки на один матч",
  "product.sb-italian-single": "Итальянские футбольные ставки на один матч",
  "product.sb-greek-single": "Греческий Soccerbet Единый матч",
  "product.sb-english-league": "Английская футбольная лига",
  "product.sb-italian-league": "Итальянская лига футбола",
  "product.sb-greek-league": "Греческая лига Soccerbet",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Сделать ставку",
  "betslip.clear": "Очистить все",
  "betslip.clearResult": "Очистить",
  "betslip.noSelections": "Выберите события для размещения ставки",
  "betslip.notLoggedIn": "Войдите чтобы сделать ставку",
  "betslip.refresh": "Обновить",
  "betslip.totalStake": "Сумма",
  "betslip.noHistoryData": "Нет информации по ставкам",
  "betslip.openBets": "Открытые ставки",
  "betslip.betHistory": "История ставок",
  "betslip.betHistoryWon": "Выигрыш",
  "betslip.betHistoryLost": "Проигрыш",
  "loading.loading": "Загрузка",
  "loading.account": "Загрузка аккаунта",
  "loading.league": "Загрузка лиги",
  "loading.gameweeks": "Загрузка игровой недели",
  "loading.markets": "Загрузка событий",
  "loading.bethistory": "Загрузка истории ставок",
  "login.loginRequired": "Требуется логин",
  "login.loginToBet": "Пожалуйста, войдите чтобы сделать ставку",
  "navigation.back": "Вернуться",
  "navigation.close": "Закрыть",
  "video.liveStreamAvailable": "Live трансляция доступна",
  "video.logInToWatch": "Пожалуйста, авторизуйтесь для просмотра",
  "error.error": "Ошибка",
  "error.404": "Страница не найдена",
  "error.gameLaunchFailed": "Невозможно запустить игру",
  "error.unknownErrorCode": "Неизвестная ошибка: {code}",
  "error.minUnitStakeLimitExceeded": "Минимальная ставка {limit}",
  "error.maxUnitStakeLimitExceeded": "Максимальная ставка {limit}",
  "error.minTotalStakeLimitExceeded": "Минимальная сумма ставки {limit}",
  "error.maxTotalStakeLimitExceeded": "Максимальная сумма ставки {limit}",
  "error.stakeInvalidMultiple": "Ставка должна быть кратна {multiple}",
  "error.notPlaced": "Ставка не размещена",
  "error.wagerDisallowed": "Ставка запрещена",
  "error.errorEventIsOff": "Событие началось",
  "wagerType.Singles": "Ординар",
  "wagerType.Doubles": "Двойники",
  "wagerType.Trebles": "Тройники",
  "wagerType.Accumulator": "Экспресс",
  "wagerType.Perm 4-Folds": "Система 4",
  "wagerType.Perm 5-Folds": "Система 5",
  "wagerType.Perm 6-Folds": "Система 6",
  "wagerType.Perm 7-Folds": "Система 7",
  "wagerType.Perm 8-Folds": "Система 8",
  "wagerType.Perm 9-Folds": "Система 9",
  "error.excess_bets": "Максимум {limit} одновременных ставок на листе ставок; пожалуйста, удалите ставку",
  "product.sb-turkish-league": "Турецкая лига Soccerbet",
  "error.minBetslipLimitExceeded": "Минимальная общая сумма ставки составляет {limit}",
  "error.maxBetslipLimitExceeded": "Максимальная общая сумма ставки составляет {limit}",
  "error.exceededMaxPayout": "Максимальная потенциальная выплата составляет {limit}; пожалуйста, уменьшите вашу ставку.",
  "betslip.potentialReturns": "Потенциальная прибыль",
  "betslip.taxDisclaimer": "Все ваши чистые выигрыши облагаются налогом при расчете ставки. Сумма налога будет рассчитана в зависимости от потенциального выигрыша по ставке.",
  "error.maintenanceEnabled": "В настоящее время сервер находится на техническом обслуживании",
  "error.internalError": "Внутренняя ошибка",
  "error.invalidSession": "Сессия недействительна",
  "error.accountDisabled": "Учетная запись отключена",
  "error.invalidPlayerID": "Неверный идентификатор игрока",
  "error.insufficientBalance": "Недостаточный баланс",
  "error.configError": "Ошибка конфигурации",
  "error.betPlaceFailed": "Не удалось сделать ставку",
  "error.invalidProductID": "Неверный идентификатор продукта",
  "error.playerReachedGamingLimits": "Игрок достиг лимита ответственных игр",
  "error.gameCycleDoesNotExist": "Игровой цикл не существует",
  "error.betAmountLimitExceeded": "Превышение лимита потенциального выигрыша для непроверенных игроков",
  "betslip.netStake": "Чистая ставка",
  "betslip.tax": "Налог",
  "error.badReturns": "Потенциальная прибыль ниже, чем валовая ставка",
  "betslip.taxDisclaimerPoland": "Выигрыш будет уменьшен на 10% для сумм, превышающих 2 280 злотых.",
  "error.incompatibleVersion": "Неподдерживаемая версия приложения. Пожалуйста, обновите.",
  "product.iihf-row-single": "Чемпионат мира по хоккею",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Вернуться к игроку",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Средний RTP для этой игры составляет {limit}",
  "error.betslipContainsInvalidOptions": "В бетслипе красным цветом выделены недействительные опционы",
  "sb-english.team.ARS": "Арсенал",
  "sb-english.team.AST": "Астон В.",
  "sb-english.team.BHA": "Брайтон",
  "sb-english.team.BOU": "Борнмут",
  "sb-english.team.BUR": "Бернли",
  "sb-english.team.CHE": "Челси",
  "sb-english.team.CRY": "К. Пэлас",
  "sb-english.team.EVE": "Эвертон",
  "sb-english.team.LEI": "Лестер",
  "sb-english.team.LIV": "Ливерпуль",
  "sb-english.team.MNC": "Манчестер С.",
  "sb-english.team.MNU": "Манчестер Ю.",
  "sb-english.team.NEW": "Ньюкасл",
  "sb-english.team.SOU": "Саутгемптон",
  "sb-english.team.TOT": "Тоттенхэм",
  "sb-english.team.WAT": "Уотфорд",
  "sb-english.team.WHU": "Вест Хэм",
  "sb-english.team.WOL": "Вульвс",
  "sb-english.team.NOR": "Норвич",
  "sb-english.team.SHU": "Шеффилд Ю.",
  "sb-english.team.LEE": "Лидс",
  "sb-english.team.FUL": "Фуллхэм",
  "sb-english.team.WBA": "Уэст Бром",
  "nomorebets": "Прием ставок закрыт",
  "playtime": "Время игры",
  "gameId": "ID игры",
  "noGames": "В данный момент отсутствуют доступные игры. Пожалуйста, попробуйте еще раз позже.",
  "Home": "Хозяева",
  "Away": "Гости",
  "Visitor": "Посетители",
  "soccerbet.gameWeek": "СЕЗОН",
  "soccerbet.noGameWeeks": "Нет доступных сезонов. Попробуйте еще раз в ближайшее время.",
  "soccerbet.league": "Таблица лиги",
  "soccerbet.table.name": "Команда",
  "soccerbet.table.won": "В",
  "soccerbet.table.drawn": "Н",
  "soccerbet.table.lost": "П",
  "soccerbet.table.points": "Очки",
  "abbr.event.Both Teams To Score": "ОЗ",
  "event.Both Teams To Score": "Обе Команды Забьют",
  "event.Over / Under": "Больше/Меньше",
  "event.Double Chance": "Двойной Результат",
  "event.Match Result": "Результат Матча",
  "event.Exact Goals": "Количество Голов",
  "event.Correct Score": "Точный Счет",
  "event.Match Result Both Score": "Результат Матча + Обе Забьют",
  "event.Result Und/Over 1.5 Total Goals": "Результат Матча + Тотал Больше/Меньше 1.5",
  "event.Result Und/Over 2.5 Total Goals": "Результат Матча + Тотал Больше/Меньше 2.5",
  "event.Under Over 1.5 Total Goals": "Тотал Больше/Меньше 1.5 голов",
  "event.Under Over 2.5 Total Goals": "Тотал Больше/Меньше 2.5 голов",
  "event.Under Over 3.5 Total Goals": "Тотал Больше/Меньше 3.5 голов",
  "event.Under Over 4.5 Total Goals": "Тотал Больше/Меньше 4.5 голов",
  "event.Total Goals 1 To 2": "Тотал от 1 до 2 голов",
  "event.Total Goals 1 To 3": "Тотал от 1 до 3 голов",
  "event.Total Goals 1 To 4": "Тотал от 1 до 4 голов",
  "event.Total Goals 2 To 3": "Тотал от 2 до 3 голов",
  "event.Total Goals 2 To 4": "Тотал от 2 до 4 голов",
  "event.Under Over 1.5 Home Goals": "Хозяева Тотал Больше/Меньше 1.5 голов",
  "event.Under Over 1.5 Away Goals": "Гости Тотал Больше/Меньше 1.5 голов",
  "event.Home Team Exact Goals": "Хозяева Количество Голов",
  "event.Away Team Exact Goals": "Гости Количество Голов",
  "selection.Yes": "Да",
  "selection.No": "Нет",
  "selection.1+G": "П1+Да",
  "selection.1+Ng": "П1+Нет",
  "selection.X+G": "Х+Да",
  "selection.X+Ng": "Х+Нет",
  "selection.2+G": "П2+Да",
  "selection.2+Ng": "П2+Нет",
  "selection.1+Yes": "1+Да",
  "selection.1+No": "1+Нет",
  "selection.X+Yes": "Х+Да",
  "selection.X+No": "Х+Нет",
  "selection.2+Yes": "2+Да",
  "selection.2+No": "2+Нет",
  "selection.TID_ANY_GOAL_SCORED_YES": "Г",
  "selection.TID_ANY_GOAL_SCORED_NO": "Нг",
  "selection.U": "М",
  "selection.O": "Б",
  "selection.1+O": "П1+Б",
  "selection.X+O": "Х+Б",
  "selection.2+O": "П2+Б",
  "selection.1+U": "П1+М",
  "selection.X+U": "Х+М",
  "selection.2+U": "П2+М",
  "selection.TID_HOME_WIN": "П1",
  "selection.TID_AWAY_WIN": "П2",
  "selection.TID_DRAW": "Х",
  "selection.TID_HOME_WIN_OR_DRAW": "П1/Х",
  "selection.TID_DRAW_OR_AWAY_WIN": "П2/Х",
  "selection.TID_HOME_OR_AWAY_WIN": "П1/П2",
  "selection.Over": "Peste",
  "selection.Under": "Sub",
  "sb-english.team.BRE": "Брентфорд",
  "abbr.sb-english.team.BRE": "БРЕ"
}
